<template>
  <Teleport :to="to">
    <button
      :id="'bk-menu-list-button-' + id"
      class="bk-menu-list-button"
      :disabled="disabled"
      :class="type ? 'bk-is-' + type : ''"
      :style="{ order: weight || 0 }"
      @click.prevent.stop="onClick"
    >
      <div class="bk-menu-list-icon">
        <slot>
          <Icon v-if="icon" :name="icon" />
        </slot>
      </div>
      <strong>{{ title }}</strong>
      <span>{{ description }}</span>
    </button>
  </Teleport>
</template>

<script setup>
import { computed, useBlokkli } from "#imports";
import { Icon } from "#blokkli/components";
import defineCommands from "#blokkli/helpers/composables/defineCommands";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  description: { type: String, required: true },
  disabled: { type: Boolean, required: false },
  icon: { type: null, required: false },
  type: { type: String, required: false },
  weight: { type: Number, required: false },
  secondary: { type: Boolean, required: false }
});
const emit = defineEmits(["click"]);
const { ui } = useBlokkli();
const to = computed(
  () => `#bk-menu-${props.secondary ? "secondary" : "primary"}`
);
function onClick() {
  ui.menu.close();
  emit("click");
}
const commandCallback = () => {
  if (!props.disabled) {
    emit("click");
  }
};
defineCommands(() => {
  return {
    id: "plugin:menu_button:" + props.id,
    group: "action",
    label: props.title,
    icon: props.icon,
    disabled: props.disabled,
    callback: commandCallback
  };
});
</script>

<script>
export default {
  name: "PluginMenuButton"
};
</script>
